"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CardDivider = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Divider = _interopRequireDefault(require("@mui/material/Divider"));
var _Card = _interopRequireDefault(require("@mui/material/Card"));
var _constants = require("./constants");
var _excluded = ["children", "className", "framed", "quiet", "selected", "twoColumns"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
var cardWithDigitalHig = function cardWithDigitalHig(BaseMuiCard) {
  var Card = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
    var children = _ref.children,
      className = _ref.className,
      framed = _ref.framed,
      quiet = _ref.quiet,
      selected = _ref.selected,
      twoColumns = _ref.twoColumns,
      otherProps = _objectWithoutProperties(_ref, _excluded);
    // MUI Card API: https://mui.com/material-ui/api/card/
    var muiCardApiPresets = {
      // children
      // classes
      // raised
      // sx
    };

    /**
     * Determines additional classnames related to "quiet" version, "framed"
     * version, and 2 col handling.
     */
    className = "".concat(className).concat(quiet ? " MuiCard--quiet" : "");
    className = "".concat(className).concat(framed ? " MuiCard--framed" : "");
    className = "".concat(className).concat(selected ? " MuiCard--selected" : "");
    className = "".concat(className).concat(twoColumns ? " MuiCard--twoColumns" : "");

    // Adding an appearance classname to bring button to parity with accordion
    // component API, but still dependant on changes resulting from
    // https://jira.autodesk.com/browse/EXPM-1100
    var appearance = _constants.appearances.DEFAULT;
    if (quiet && framed) {
      appearance = _constants.appearances.QUIET_AND_FRAMED;
    }
    if (quiet && !framed) {
      appearance = _constants.appearances.QUIET;
    }
    if (!quiet && framed) {
      appearance = _constants.appearances.FRAMED;
    }
    className = "".concat(className, " DhigCard--appearance--").concat(appearance);
    return /*#__PURE__*/_react.default.createElement(BaseMuiCard, _extends({}, muiCardApiPresets, otherProps, {
      className: className,
      ref: ref
    }), children);
  });
  Card.displayName = "Card";
  Card.defaultProps = {
    className: "",
    framed: false,
    quiet: false,
    twoColumns: false
  };
  Card.propTypes = {
    children: _propTypes.default.node.isRequired,
    className: _propTypes.default.string,
    framed: _propTypes.default.bool,
    quiet: _propTypes.default.bool,
    selected: _propTypes.default.bool,
    twoColumns: _propTypes.default.bool
  };
  return Card;
};
var CardDivider = exports.CardDivider = function CardDivider(props) {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "DhigCard--divider"
  }, /*#__PURE__*/_react.default.createElement(_Divider.default, _extends({
    light: true
  }, props)));
};
var Card = cardWithDigitalHig(_Card.default);
var _default = exports.default = Card;
CardDivider.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "CardDivider"
};